import { render, staticRenderFns } from "./certificationPanel.vue?vue&type=template&id=405e9dc5&scoped=true&"
import script from "./certificationPanel.vue?vue&type=script&lang=js&"
export * from "./certificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./certificationPanel.vue?vue&type=style&index=0&id=405e9dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e9dc5",
  null
  
)

export default component.exports